import React from "react";
import "./Footer.css";
import { FaEnvelope, FaFacebook, FaLinkedin } from "react-icons/fa";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <h2>Centre for Interdisciplinary Programs</h2>
          <div className="gap10"></div>
          <p>
            The Centre for Interdisciplinary Programs at IIT Hyderabad fosters
            innovation and collaboration across diverse fields. By integrating
            knowledge from multiple disciplines, we aim to create unique
            educational programs, drive research, and address real-world
            challenges.
          </p>
          <div className="gap10"></div>
          {/* <img className="iithlogo_footer" src={iithlogo} alt="IIT Hyderabad Logo" /> */}
        </div>

        <div className="footer-links">
          <div className="footer-link-group">
            <h3>Main Links</h3>
            <ul>
              <li>
                <a href="/">Homepage</a>
              </li>
              <li>
                <a href="/about">About Us</a>
              </li>
              <li>
                <a href="/programs">Programs</a>
              </li>
              <li>
                <a href="/#news-events">News & Events</a>
              </li>
              <li>
                <a href="/contactus">Contact Details</a>
              </li>
              <li>
                <a href="/research">Research</a>
              </li>
            </ul>
          </div>

          <div className="footer-link-group">
            <h3>Admissions</h3>
            <ul>
              <li>
                <a href="/progms">M.Sc</a>
              </li>
              <li>
                <a href="/progmtech">M.Tech</a>
              </li>
              <li>
                <a href="/progphd">PhD</a>
              </li>
              <li>
                <a href="/progjdp">JDP</a>
              </li>
            </ul>
          </div>

          <div className="footer-link-group">
            <h3>People</h3>
            <ul>
              <li>
                <a href="/people/staff">Staff</a>
              </li>
              <li>
                <a href="/people/pg-students">PG Students</a>
              </li>
              <li>
                <a href="/people/phd-students">PhD Students</a>
              </li>
              <li>
                <a href="/people/alumni">Alumni</a>
              </li>
            </ul>
          </div>

          <div className="footer-link-group">
            <h3>Useful Links</h3>
            <ul>
              <li>
                <a
                  href="https://www.iith.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IITH
                </a>
              </li>
              <li>
                <a
                  href="https://www.iith.ac.in/academics/calendars-timetables/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Academic Calendar
                </a>
              </li>
              <li>
                <a
                  href="https://cfhe.iith.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  CFHE
                </a>
              </li>
              <li>
                <a
                  href="https://cip.iith.ac.in/icmp/Home.html"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  ICMP
                </a>
              </li>
              <li>
                <a
                  href="http://trp.iith.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  IITH TRP
                </a>
              </li>
              <li>
                <a
                  href="https://ope.cip.iith.ac.in/home"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  OPE
                </a>
              </li>
              <li>
                <a
                  href="https://i-tic.iith.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  i-TIC
                </a>
              </li>
              <li>
                <a
                  href="http://sunshine.iith.ac.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sunshine
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="footer-social">
        <a
          href="mailto:office@cip.iith.ac.in"
          className="footer-icons"
          aria-label="Email CIP office"
        >
          <FaEnvelope />
        </a>
        <a
          href="https://www.facebook.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-icons"
          aria-label="CIP Facebook"
        >
          <FaFacebook />
        </a>
        <a
          href="https://www.linkedin.com"
          target="_blank"
          rel="noopener noreferrer"
          className="footer-icons"
          aria-label="CIP LinkedIn"
        >
          <FaLinkedin />
        </a>
      </div>

      <div className="footer-bottom">
        <p>Website Created and Maintained by: Jash Jhatakia</p>
        <p>
          &copy; Centre for Interdisciplinary Programs, Indian Institute of
          Technology Hyderabad.
        </p>
        <p>All Rights Reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
